import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, ShieldCheck, Zap, Layers } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { heroImages, stats, whyUs } from "../mock";

const icons = [Zap, ShieldCheck, Layers];

export default function About() {
  return (
    <main>
      <PageHero
        title="About LTR Capital Partners"
        crumb="About"
        subtitle="A premier commercial mortgage service provider helping investors and businesses secure funding — even when conventional lenders say no."
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid gap-14 lg:grid-cols-2 items-center">
          <Reveal>
            <img src={heroImages.meeting} alt="LTR Capital Partners team" className="rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]" />
          </Reveal>
          <Reveal delay={120}>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Our Story</p>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
              Your Partner In Real Estate Investment
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              We provide commercial real estate finance for investment properties as well as funding
              to small, medium and large businesses. As one of the premier mortgage service providers
              in the United States, we offer real estate financing for all kinds of investment
              properties — including commercial, industrial, multi-family, mixed-use and more.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Whether you are looking to secure working capital for inventory, payroll, marketing and
              taxes, or exploring small business lending solutions including equipment financing, we
              are here to help. Our exceptional reputation as a hard money / private money lender has
              been built on our ability to provide quick financing solutions for borrowers.
            </p>
            <Link to="/apply" className="mt-8 inline-flex items-center gap-2 rounded-md bg-[#c6a15b] px-6 py-3 font-bold text-[#0b1f3a] hover:bg-[#d8bc85] transition-colors">
              Get Started <ArrowRight className="h-5 w-5" />
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="py-16 bg-[#0b1f3a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 80}>
              <div className="text-center">
                <div className="font-display text-4xl font-extrabold text-[#c6a15b]">{s.value}</div>
                <div className="mt-2 text-sm text-slate-300">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="text-center max-w-2xl mx-auto">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Our Advantage</p>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">Why Choose LTR Capital</h2>
          </Reveal>
          <div className="mt-14 grid gap-8 md:grid-cols-3">
            {whyUs.map((w, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={w.title} delay={i * 100}>
                  <div className="h-full rounded-2xl ring-1 ring-slate-100 p-8 hover:shadow-xl transition-shadow">
                    <div className="h-14 w-14 rounded-xl bg-[#0b1f3a] flex items-center justify-center">
                      <Icon className="h-7 w-7 text-[#c6a15b]" />
                    </div>
                    <h3 className="font-display font-bold text-xl text-[#0b1f3a] mt-6">{w.title}</h3>
                    <p className="mt-3 text-slate-600 leading-relaxed">{w.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
